import React, { ButtonHTMLAttributes, useState } from 'react';
import './MenuIcon.scss';

export interface MenuIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {};


const UHCMenuIcon: React.FC<MenuIconProps> = (props: MenuIconProps) => { 

    const [selectIcon, setSelectIcon] = useState('menu');

    function handleClick(type: string) {
        setSelectIcon(type);
    }

    return (
        <div className='icon-div' data-testid='container'>
            <div
                data-testid='UHCMenuIcon'
                onClick={() => handleClick('menu')}
                className={`icon menu ${selectIcon === 'menu' ? 'selected' : ''}`}>
                <div className='vertical' />
                <div className='horizontal' />
            </div>
            <div
                data-testid='UHCListIcon'
                onClick={() => handleClick('list')}
                className={`icon list ${selectIcon === 'list' ? 'selected' : ''}`}>
                <div className='horizontal' />
                <div className='horizontal' />
            </div>
        </div>
    )
}

export default UHCMenuIcon;